import { render, staticRenderFns } from "./NewsFromAdmin.vue?vue&type=template&id=0ee6bb65"
import script from "./NewsFromAdmin.vue?vue&type=script&lang=ts"
export * from "./NewsFromAdmin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports